
































import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment-timezone';
import * as utils from '@/lib/utils';

export default Vue.extend({
    props: {
        search: {
            type: String,
        },
        typeList: {
            required: true,
            type: Array,
        },
    },
    components: {},
    data() {
        return {
            typeMap: [] as any,
            filters: {
                status: 'all',
            },
        };
    },
    computed: {
        ...mapState('toasts', ['toasts', 'toastsLoading']),
    },
    methods: {
        getHeaders() {
            return [
                {
                    text: 'Name',
                    value: 'name',
                    width: 110,
                },
                {
                    text: 'Type',
                    value: 'style',
                    width: 110,
                },
                {
                    text: 'Active since',
                    value: 'activeSince',
                    width: 110,
                },
                {
                    text: 'Active Until',
                    value: 'activeUntil',
                    width: 110,
                },
                {
                    text: 'Status',
                    value: 'active',
                    width: 110,
                },
                {
                    text: 'Title',
                    value: 'title',
                    width: 110,
                },
                {
                    text: 'Sub title',
                    value: 'subtitle',
                    width: 110,
                },
                {
                    text: 'Action',
                    value: 'action',
                    width: 50,
                },
            ];
        },
        getTypeFromList(color: string) {
            return this.typeMap[color];
        },
        getToastStatus(item: any): string {
            const current = new Date().toISOString().substr(0, 10);
            const { activeUntil, activeSince } = item;
            const isBetween = moment(current).isSameOrAfter(activeSince) && moment(current).isSameOrBefore(activeUntil);
            const isExpired = moment(current).isAfter(activeUntil);
            if (!item.active) {
                return 'disabled';
            }
            if (isBetween) {
                return 'active';
            }
            if (isExpired) {
                return 'expired';
            }
            return 'pending';
        },
        onRowSelect(row: any, rowDetails: any) {
            this.$emit('openForm', row);
        },
        getFormatTime(item: any): string {
            return utils.convertDateToAmericanFormat(item);
        },
    },
    created() {
        this.typeList.forEach((element: any) => {
            this.typeMap[element.style] = element.name;
        });

    },
});
